import Link from 'next/link';
import cx from 'classnames';

import { ShoppingCartCount } from '../../primary-navigation/components/ShoppingCartMenuItem';
import { MobileNavButtonProps } from '../MobileNavigation.types';
import { Icon } from '@goed/ui-components';

export const MobileNavButton: React.FC<MobileNavButtonProps> = ({
    title,
    link,
    slug,
    onClick,
    variant = 'primary',
    iconBefore,
    iconAfter,
    count,
    openInNewWindow,
}: MobileNavButtonProps): JSX.Element => {
    const classNames = cx(
        'mobile-nav-btn',
        `mobile-nav-btn--${variant}`,
        link ? 'mobile-nav-btn--link' : 'mobile-nav-btn--button'
    );

    if (slug) {
        return (
            <Link href={`${slug}`}>
                <a className={classNames} target={openInNewWindow ? '_blank' : undefined}>
                    {iconBefore && <Icon name={iconBefore} />}
                    <span className="mobile-nav-btn__label">{title}</span>
                    {iconAfter && <Icon name={iconAfter} />}
                    {count && <ShoppingCartCount count={count} />}
                </a>
            </Link>
        );
    }

    return (
        <button onClick={onClick} className={classNames}>
            {iconBefore && <Icon name={iconBefore} />}
            <span className="mobile-nav-btn__label">{title}</span>
            {iconAfter && <Icon name={iconAfter} />}
            {count && <ShoppingCartCount count={count} />}
        </button>
    );
};
